module.exports = __webpack_public_path__ + "img/a1.e6845562.jpg";